import axios from 'axios'

const baseUrl = '/api/tests'

export class TestService {
    // Get tests
    static getVehicleTestsPaged(pageSize, requestPage, searchTerm) {
        return new Promise(async (resolve, reject) => {
            try {
                pageSize = pageSize || 10
                requestPage = requestPage || 0                
                searchTerm = searchTerm ? `&searchTerm=${searchTerm}` : ''
                let url = `${baseUrl}/?page_size=${pageSize}&page=${requestPage}${searchTerm}`
                let results = await axios.get(url)
                resolve(results.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }

    // Get test by Id
    static getVehicleTestById(testId) {
        return new Promise(async (resolve, reject) => {
            try {
                let url = `${baseUrl}/${testId}?expand=media`
                let result = await axios.get(url)
                resolve(result.data)
            }
            catch (err) {
                reject(err)
            }
        })
    }


}